import type { Country } from '@sunwebgroup/uds-ui/fields/phone-field'
import type { ParticipantEditPhoneFormValue } from '../../../domain/types'
import { formatPhoneNumberInput } from '@/scopes/common/components/FormElements/PhoneFormatter'

export function toPhoneFormValues(values: string[], defaultCountry: Country): ParticipantEditPhoneFormValue[] {
  return values.map(value => toPhoneFormValue(value, defaultCountry))
}

function toPhoneFormValue(value: string, defaultCountry: Country): ParticipantEditPhoneFormValue {
  const { prefix, phoneNumber } = formatPhoneNumberInput(value, defaultCountry.code, defaultCountry.isoCode.toLowerCase())
  return { countryCode: prefix, phoneNumber }
}
